import { render, staticRenderFns } from "./TheSubHeader.vue?vue&type=template&id=53c0de2f&scoped=true&"
import script from "./TheSubHeader.vue?vue&type=script&lang=js&"
export * from "./TheSubHeader.vue?vue&type=script&lang=js&"
import style0 from "./TheSubHeader.vue?vue&type=style&index=0&id=53c0de2f&lang=scss&scoped=true&"
import style1 from "./TheSubHeader.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c0de2f",
  null
  
)

export default component.exports